const tra = {
  MIN_VALUE: {
    message: 'Transfer value can not be R$0,00'
  },
  MAX_VALUE: {
    message: 'Transfer value can not be greater than R${{maxValue}}'
  },
  FORMAT_ERROR: {
    message: 'Wrong format of a transfer field content'
  },
  PAYMENT_DATE_BEFORE_CURRENT_DATE: {
    message: 'Payment date before current date'
  },
  INVALID_TEV_PROCESSING_HOUR: {
    message: 'Schedules for today are allowed until 7PM'
  },
  INVALID_TED_PROCESSING_HOUR: {
    message: 'TED schedules for today are allowed until 4:30PM'
  },
  MAX_PAYMENT_DATE: {
    message: 'You can not schedule a transfer after 30 days'
  },
  BUSINESS_DAY: {
    message: 'We process transfers only on business days, you need to change the date to a business day'
  },
  PAYMENT_DATE_WRONG_DATE_FORMAT: {
    message: 'Wrong payment date format'
  },
  NOT_SCHEDULED_OUT_OF_TIME: {
    message: 'You have payments that will be made on the next business day'
  },
  DUPLICATED_INTEGRATION_ID: {
    message: 'Duplicated integration id'
  },
  DBA_REMOVED: {
    message: 'Destination bank account is removed'
  },
  INVALID_PAYMENT_METHOD: {
    message: 'Invalid payment method'
  },
  CANT_SCHEDULE_PIX_PAYMENT_WITH_KEY: {
    message: 'You cannot schedule a PIX payment with key'
  },
  MAX_DECIMAL_PLACES: {
    message: 'Transfer value can not exceed 2 decimal places'
  },
  INVALID_PIX_DESCRIPTION_LENGTH: {
    message: 'Pix description can not be greater than 140 characters'
  },
  INVALID_PIX_DESCRIPTION_FORMAT: {
    message: 'Invalid Pix description format'
  },
  RECEIPT_BATCH_DOWNLOAD_LIMIT_EXCEEDED: {
    message:
      'More than {{maxTransfersAllowed}} transfers have been identified. Try applying more filters and try again.'
  }
};

module.exports = tra;
